import styled from "styled-components"

export default styled.div`
  align-items: center;
  background: linear-gradient(
    180deg,
    ${props => props.theme.backgroundGradientLight} 80%,
    ${props => props.theme.backgroundGradientDark}
  );
  height: 100px;
  padding: 18px 40px;
  width: 100%;
  display: flex;
  flex-direction: row;
  position: absolute;
  bottom: 0;
  left: 0;
`

export const KioskNavBarLink = styled.a`
  color: #fff;
  font-family: "din-condensed";
  font-weight: 400;
  text-decoration: none;
  text-transform: uppercase;
  font-size: 1.2rem;
`



// WEBPACK FOOTER //
// ./src/Kiosk/KioskNavBar.js